import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Form as FormikForm, TextField, InputField, DateTimePickerField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import Button from "components/common_components/Button";

function MasterForm({ masterData, resources, mode, ...rest }) {
    const adding = mode === "add";
    const updating = mode === "update";
    const { user } = useSelector((state) => state.Login);

    const getInitialValues = () => {
        if (adding || !masterData) {
            return {
                id: null,
                date: new Date(),
                userId: user.id,
                userName: user.name,
                notes: "",
            };
        }

        const { id, date, userId, userName, notes } = masterData;
        return {
            id,
            date,
            userId,
            userName,
            notes: notes || "",
        };
    };

    return (
        <div className="layout">
            <FormikForm validateOnChange={false} initialValues={getInitialValues()} showButtons={false} {...rest}>
                {(form) => (
                    <>
                        <Grid item>
                            <Grid container direction="row" spacing={2} alignItems="flex-start">
                                <Grid item xs={3}>
                                    <Grid container direction="column" spacing={2}>
                                        <Grid item>
                                            <DateTimePickerField disabled fieldName="date" label="Date" />
                                        </Grid>
                                        <Grid item>
                                            <InputField disabled fieldName="userName" label="Responsible" light compact />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={9}>
                                    <Grid container direction="column" spacing={2}>
                                        <Grid item>
                                            <TextField fieldName="notes" label="Notes" multiline minRows={1} />
                                        </Grid>
                                        {updating && (
                                            <Grid item>
                                                <Button link secondary type="submit" loading={form.isSubmitting}>
                                                    Save notes
                                                </Button>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {adding && (
                            <Grid item>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item>
                                        <Button outline onClick={rest.onCancel}>
                                            Back
                                        </Button>
                                    </Grid>

                                    <Grid item>
                                        <Button primary type="submit" loading={form.isSubmitting}>
                                            Start
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </>
                )}
            </FormikForm>
        </div>
    );
}

MasterForm.propTypes = {
    masterData: PropTypes.shape({
        id: PropTypes.number,
        date: PropTypes.instanceOf(Date),
        userId: PropTypes.number,
        userName: PropTypes.string,
        notes: PropTypes.string,
    }),
    mode: PropTypes.oneOf(["add", "update"]).isRequired,
};

MasterForm.defaultProps = {
    masterData: undefined,
};

export default MasterForm;
